import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

const configureApolloClient = urlPrefix =>
  new ApolloClient({
    cache: new InMemoryCache(),
    link: createHttpLink({
      uri: `${urlPrefix}/graphql`,
      credentials: 'same-origin',
      headers: {
        'client-name': 'node-homepage',
        'client-version': '1.0.0'
      }
    })
  });

export default configureApolloClient;
